/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Heading2Inputs */

const zh_landing_audience_heading2 = /** @type {(inputs: Landing_Audience_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每一位老师`)
};

const en_landing_audience_heading2 = /** @type {(inputs: Landing_Audience_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`every teacher`)
};

const es_landing_audience_heading2 = /** @type {(inputs: Landing_Audience_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cada docente`)
};

/**
* | output |
* | --- |
* | "every teacher" |
*
* @param {Landing_Audience_Heading2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_heading2 = /** @type {((inputs?: Landing_Audience_Heading2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Heading2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_heading2(inputs)
	if (locale === "en") return en_landing_audience_heading2(inputs)
	return es_landing_audience_heading2(inputs)
});